import { Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { APP_VERSION } from '../version';

import ThemeSettings from '../components/Admin/ThemeSettings';
import CategoryManager from '../components/Admin/CategoryManager';
import PageManager from '../components/Admin/PageManager';
import NewsManager from '../components/Admin/NewsManager';
import CarouselManager from '../components/Admin/CarouselManager';
import UserManager from '../components/Admin/UserManager';
import BookingManager from '../components/Admin/BookingManager';
import SiteSettings from '../components/Admin/SiteSettings';

function AdminDashboard() {
  const { logout, user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => {
    if (path === '/admin' && location.pathname === '/admin') return true;
    if (path !== '/admin' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <h2>Admin Panel</h2>
        <nav className="admin-nav">
          <Link to="/admin" className={isActive('/admin') && location.pathname === '/admin' ? 'active' : ''}>
            Dashboard
          </Link>
          <Link to="/admin/categories" className={isActive('/admin/categories') ? 'active' : ''}>
            Categories
          </Link>
          <Link to="/admin/pages" className={isActive('/admin/pages') ? 'active' : ''}>
            Pages
          </Link>
          <Link to="/admin/news" className={isActive('/admin/news') ? 'active' : ''}>
            Novidades
          </Link>
          <Link to="/admin/carousel" className={isActive('/admin/carousel') ? 'active' : ''}>
            Carousel
          </Link>
          <Link to="/admin/bookings" className={isActive('/admin/bookings') ? 'active' : ''}>
            Bookings
          </Link>
          <Link to="/admin/users" className={isActive('/admin/users') ? 'active' : ''}>
            Users
          </Link>
          <Link to="/admin/theme" className={isActive('/admin/theme') ? 'active' : ''}>
            Theme
          </Link>
          <Link to="/admin/settings" className={isActive('/admin/settings') ? 'active' : ''}>
            Site Settings
          </Link>
        </nav>
        <div style={{ marginTop: 'auto', paddingTop: '20px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', marginBottom: '10px' }}>
            Logged in as: {user?.username}
          </p>
          <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', opacity: 0.8 }}>
            v{APP_VERSION}
          </p>
          <Link to="/" style={{ display: 'block', marginBottom: '10px', fontSize: '0.9rem' }}>
            ← Back to Site
          </Link>
          <button onClick={handleLogout} className="btn btn-small btn-secondary" style={{ width: '100%' }}>
            Logout
          </button>
        </div>
      </aside>
      
      <main className="admin-content">
        <Routes>
          <Route path="/" element={<AdminHome />} />
          <Route path="/categories" element={<CategoryManager />} />
          <Route path="/pages" element={<PageManager />} />
          <Route path="/news" element={<NewsManager />} />
          <Route path="/carousel" element={<CarouselManager />} />
          <Route path="/bookings" element={<BookingManager />} />
          <Route path="/users" element={<UserManager />} />
          <Route path="/theme" element={<ThemeSettings />} />
          <Route path="/settings" element={<SiteSettings />} />
        </Routes>
      </main>
    </div>
  );
}

function AdminHome() {
  return (
    <div>
      <h1>Welcome to Admin Dashboard</h1>
      <p style={{ color: 'var(--text-secondary)', marginTop: '10px' }}>
        Manage your wedding clothes website from here.
      </p>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginTop: '40px' }}>
        <Link to="/admin/categories" style={{ 
          padding: '30px', 
          backgroundColor: 'var(--background-secondary)', 
          borderRadius: '8px',
          textAlign: 'center',
          color: 'var(--text)'
        }}>
          <h3>Categories</h3>
          <p style={{ color: 'var(--text-secondary)', marginTop: '10px', fontSize: '0.9rem' }}>
            Organize your collections
          </p>
        </Link>
        
        <Link to="/admin/pages" style={{ 
          padding: '30px', 
          backgroundColor: 'var(--background-secondary)', 
          borderRadius: '8px',
          textAlign: 'center',
          color: 'var(--text)'
        }}>
          <h3>Pages</h3>
          <p style={{ color: 'var(--text-secondary)', marginTop: '10px', fontSize: '0.9rem' }}>
            Content pages with photos and catalog links
          </p>
        </Link>
        
        <Link to="/admin/news" style={{ 
          padding: '30px', 
          backgroundColor: 'var(--background-secondary)', 
          borderRadius: '8px',
          textAlign: 'center',
          color: 'var(--text)'
        }}>
          <h3>Novidades</h3>
          <p style={{ color: 'var(--text-secondary)', marginTop: '10px', fontSize: '0.9rem' }}>
            Novidades com imagem, título e texto
          </p>
        </Link>
        
        <Link to="/admin/carousel" style={{ 
          padding: '30px', 
          backgroundColor: 'var(--background-secondary)', 
          borderRadius: '8px',
          textAlign: 'center',
          color: 'var(--text)'
        }}>
          <h3>Carousel</h3>
          <p style={{ color: 'var(--text-secondary)', marginTop: '10px', fontSize: '0.9rem' }}>
            Home page slides (3 or more photos)
          </p>
        </Link>
        
        <Link to="/admin/bookings" style={{ 
          padding: '30px', 
          backgroundColor: 'var(--background-secondary)', 
          borderRadius: '8px',
          textAlign: 'center',
          color: 'var(--text)'
        }}>
          <h3>Bookings</h3>
          <p style={{ color: 'var(--text-secondary)', marginTop: '10px', fontSize: '0.9rem' }}>
            Confirm and set date/time
          </p>
        </Link>
        
        <Link to="/admin/theme" style={{ 
          padding: '30px', 
          backgroundColor: 'var(--background-secondary)', 
          borderRadius: '8px',
          textAlign: 'center',
          color: 'var(--text)'
        }}>
          <h3>Theme</h3>
          <p style={{ color: 'var(--text-secondary)', marginTop: '10px', fontSize: '0.9rem' }}>
            Customize colors
          </p>
        </Link>
      </div>
    </div>
  );
}

export default AdminDashboard;
